import s from '../../sass/skeleton.scss';
import { Box } from '@wix/design-system';
import type { FC } from 'react';
import React from 'react';
import { SkeletonAppBox } from '../../components/skeletons/app-box-skeleton';

interface AppGridSkeletonProps {
  boxCount: number;
  columns?: 3 | 4;
  dataHook?: string;
}

export function AppGridSkeleton({
  boxCount,
  columns,
  dataHook,
}: AppGridSkeletonProps) {
  const SkeletonGrid: FC = () => {
    return (
      <>
        {Array.from({ length: boxCount }).map((_value, index) => (
          <Box width="280px" height="215px" key={index}>
            <SkeletonAppBox />
          </Box>
        ))}
      </>
    );
  };

  return (
    <Box
      dataHook={dataHook ?? 'app-grid-skeleton'}
      gap="24px"
      className={columns ? s[`skeleton-grid-${columns}`] : s.skeletonGrid}
    >
      <SkeletonGrid />
    </Box>
  );
}
